import { Dispatch, SetStateAction, useMemo } from 'react'
import { useUser } from '../../../../fetchData/queries/useUser'
import { FinalAccountModalContent } from '../MenuButtonModal/Content/FinalAccountModalContent'
import { ResultCalculationModalContent } from '../MenuButtonModal/Content/ResultCalculationModalContent'
import { useEvaluateAccounting } from '../../../../fetchData/queries/accounting/useEvaluateAccounting'
import { MenuItemProps } from '../MenuButton'

export const useAccountingMenu = (
  setModalContent: Dispatch<
    SetStateAction<{ header: string; body: JSX.Element }>
  >,
  setIsModalOpen: Dispatch<SetStateAction<boolean>>,
  setModalLock: Dispatch<SetStateAction<boolean>>
) => {
  const scopes = useUser()?.data?.scopes
  const evaluateAccounting = useEvaluateAccounting()

  const menuItems = useMemo(() => {
    const items: MenuItemProps[] = []

    if (scopes?.['accounting_create']) {
      const handleManualResCalc = () => {
        setModalContent({
          header: 'Manuell resultatavräkning',
          body: (
            <ResultCalculationModalContent
              setIsModalOpen={setIsModalOpen}
              setModalLock={setModalLock}
            />
          ),
        })
        setIsModalOpen(true)
      }

      const manualResCalc: MenuItemProps = {
        key: 'manualResCalc',
        text: 'Manuell resultatavräkning',
        onClick: handleManualResCalc,
        disabled: !evaluateAccounting.data?.isValid,
      }

      const handleFinalAccount = () => {
        setModalContent({
          header: 'Slutredovisning',
          body: (
            <FinalAccountModalContent
              setIsModalOpen={setIsModalOpen}
              setModalLock={setModalLock}
            />
          ),
        })
        setIsModalOpen(true)
      }

      const finalAccount: MenuItemProps = {
        key: 'finalAccount',
        text: 'Slutredovisning',
        onClick: handleFinalAccount,
        disabled: !evaluateAccounting.data?.isValid,
      }

      items.push(manualResCalc, finalAccount)
    }

    return items
  }, [
    evaluateAccounting,
    scopes,
    setIsModalOpen,
    setModalContent,
    setModalLock,
  ])

  return menuItems
}
